import { TLocationType } from '../../modules/API/Warehouse/models/locations'

export interface ILocationTypeOption {
    value: TLocationType
    label: string
}

export const LOCATION_TYPE_OPTIONS: ILocationTypeOption[] = [
    { value: 1, label: 'ליקוט' },
    { value: 2, label: 'אחסון' },
]

export const DEFAULT_LOCATION_TYPE: TLocationType = 1

/** 1 / 2 (number or numeric string) → that type; anything else → null. */
export const toLocationType = (value: unknown): TLocationType | null => {
    const code = Number(value)
    return code === 1 || code === 2 ? code : null
}

/** Code → label; an unknown code is shown as is, an empty value as ''. */
export const resolveLocationTypeLabel = (value: unknown): string => {
    const code = toLocationType(value)
    return LOCATION_TYPE_OPTIONS.find((option) => option.value === code)?.label ?? String(value ?? '')
}

/** Filter value for "all types" — not a LocationType itself. */
export const LOCATION_TYPE_ALL = 0
export type TLocationTypeFilter = typeof LOCATION_TYPE_ALL | TLocationType

/** Type filter choices: הכל, then every type. */
export const LOCATION_TYPE_FILTER_OPTIONS: { value: TLocationTypeFilter; label: string }[] = [
    { value: LOCATION_TYPE_ALL, label: 'הכל' },
    ...LOCATION_TYPE_OPTIONS,
]

/** "All" → the same list; a type → only rows of that type (rows without a type show only under "all"). */
export const filterByLocationType = <T extends { LocationType?: unknown }>(
    list: T[],
    filter: TLocationTypeFilter,
): T[] =>
    filter === LOCATION_TYPE_ALL
        ? list
        : list.filter((row) => toLocationType(row.LocationType) === filter)

/** The preferred type if any row has it, otherwise "all" — so a default view is never empty for no reason. */
export const defaultLocationTypeFilter = <T extends { LocationType?: unknown }>(
    list: T[],
    preferred: TLocationType,
): TLocationTypeFilter =>
    list.some((row) => toLocationType(row.LocationType) === preferred) ? preferred : LOCATION_TYPE_ALL
